import { render, staticRenderFns } from "./InventoryBaseCount.vue?vue&type=template&id=38b40e88"
import script from "./InventoryBaseCount.vue?vue&type=script&lang=js"
export * from "./InventoryBaseCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports